import { ProductDetailsSectionEligibilityTi } from '../Sections/Eligibility/ProductDetailsSectionEligibilityTi';
import { ProductDetailsSectionPolicyDocuments } from '../Sections/PolicyDocuments/ProductDetailsSectionPolicyDocuments';
import { ProductDetailsSectionGift } from '../Sections/ProductDetailsSectionGift';
import { ProductDetailsSectionHighlights } from '../Sections/ProductDetailsSectionHighlights';
import { ProductDetailsStickyFooterTi } from '../Sections/StickyFooter/ProductDetailsStickyFooterTi';
import { StickyNavigationBarTi } from '../Sections/StickyNavigationBar/StickyNavigationBarTi';
import { visibleSections } from '../utils/sections';
import {
  hasProductOffers,
  isHighlightsSectionVisible,
  isPolicyDocumentsSectionVisible,
  isTiEligibilitySectionVisible,
} from '../utils/sectionVisibility/sectionVisibility';
import { SectionBuilder } from './types';

/**
 * Travel Insurance provider page (CMS-1643 / CMS-1644), rendered for the active tier's product the
 * fe TI wrapper supplies: offers, highlights, the editor-configured eligibility rows (M6) and the
 * policy documents — no benefits / fees — with the TI sticky nav. Policy documents render without a
 * nav tab (CMS-1643 §3) and only on the page, never in the modal.
 */
export const buildTravelInsuranceSections: SectionBuilder = (
  props,
  staticText,
) => {
  const { product, vertical, pushDataLayer, tiEligibilityRows } = props;
  const isModal = props.renderingMode === 'MODAL';

  return {
    Navigation: StickyNavigationBarTi,
    // The provider page's footer is the fe wrapper's tier-aware StickyFooterCta (CMS-1643).
    Footer:
      props.renderingMode === 'TI_PROVIDER'
        ? null
        : ProductDetailsStickyFooterTi,
    sections: visibleSections([
      {
        id: 'offers',
        label: staticText.pd_nav_offers,
        visible: hasProductOffers(product),
        render: () => (
          <ProductDetailsSectionGift
            {...product}
            vertical={vertical}
            pushDataLayer={pushDataLayer}
          />
        ),
      },
      {
        id: 'highlights',
        label: staticText.pd_nav_highlights,
        visible: isHighlightsSectionVisible(product),
        render: () => (
          <ProductDetailsSectionHighlights
            {...product}
            pushDataLayer={pushDataLayer}
          />
        ),
      },
      {
        id: 'eligibility',
        label: staticText.pd_nav_eligibility,
        visible: isTiEligibilitySectionVisible(product, tiEligibilityRows),
        render: () => (
          <ProductDetailsSectionEligibilityTi
            product={product}
            rows={tiEligibilityRows}
          />
        ),
      },
      {
        id: 'policy-documents',
        visible: !isModal && isPolicyDocumentsSectionVisible(product),
        render: () => <ProductDetailsSectionPolicyDocuments product={product} />,
      },
    ]),
  };
};
